import { Spin, SpinProps } from 'antd'
import React from 'react'
import { JSX } from 'react/jsx-runtime'

import s from './ThreeDotLoader.module.scss'

const ThreeDotLoader: React.FC = () => {
  return (
    <div className={s.loader}>
      <span className={s.dot} />
      <span className={s.dot} />
      <span className={s.dot} />
    </div>
  )
}

const CustomSpin = (props: JSX.IntrinsicAttributes & SpinProps) => <Spin indicator={<ThreeDotLoader />} {...props} />

export default CustomSpin
